module.exports = __webpack_public_path__ + "img/theme_dark_round.92ba8f.svg";